import { memo, type SVGProps } from 'react'

const SvgChevronUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.667 13.5 15.833 8 10 13.5M21.667 18l-5.834 5.5L10 18"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const Memo = memo(SvgChevronUpDown)
export default Memo
